import { StorageAction, StorageActionType } from "../actions/storage";
import { IShardRepository, ShardRepositoryListItem } from "../../api/entities/shard-repository";
import { IShardClusterListItem } from "../../api/entities/shard-cluster";

export interface IStorageState {
  storageList: ShardRepositoryListItem[];
  uniqueNameCheck: boolean;
  testConnectionFlag: boolean;
  showTable: boolean;
  storageNodeDetail: IShardRepository;
  addStoragePoolFlag: boolean;
  defaultStoragePool: IShardClusterListItem[];
}

export const STORAGE_DEFAULT_STATE: IStorageState = {
  storageList: [],
  uniqueNameCheck: false,
  testConnectionFlag: null,
  showTable: null,
  storageNodeDetail: null,
  addStoragePoolFlag: false,
  defaultStoragePool: [],
};

export default function storage(
  state = STORAGE_DEFAULT_STATE,
  action: StorageAction
): IStorageState {
  
  switch (action.type) {
    case StorageActionType.STORAGE_LISTING:
      return {
        ...state,
        storageList: action.payload,
      };
    case StorageActionType.CHECK_UNIQUE_NAME:
      return {
        ...state,
        uniqueNameCheck: action.data,
      };

    case StorageActionType.SET_TEST_CONNECTION_FLAG:
      return {
        ...state,
        testConnectionFlag: action.flag,
      };
    case StorageActionType.SET_STORAGE_NODE_DETAIL:
      return {
        ...state,
        storageNodeDetail: action.data,
      };
    default:
      return state;
  }
}
